import { configureStore } from '@reduxjs/toolkit'
import {
	usersApi,
	accountApi,
	propertiesApi,
	contactsApi,
	dealsApi,
	dealMessagesApi,
	dealMeetingsApi,
	dealNotesApi,
	dealTasksApi,
	dealHistoryApi,
	rentalsApi,
	rentalAutomationApi,
	rentalNotesApi,
	rentalTasksApi,
	rentalMessagesApi,
	rentalHistoryApi,
	rentalDocumentsApi,
	invoicesApi,
	financesApi,
	documentsApi,
	integrationApi,
	dashboardApi,
	tasksApi,
	notificationsApi,
	builderApi,
} from '@rentflowdev/api'
import { dealStageOverridesReducer } from '@/store/deal-stage-overrides.slice'
import { sidebarOverrideReducer } from '@/store/sidebar-override.slice'

export const store = configureStore({
	reducer: {
		dealStageOverrides: dealStageOverridesReducer,
		sidebarOverride: sidebarOverrideReducer,
		[usersApi.reducerPath]: usersApi.reducer,
		[accountApi.reducerPath]: accountApi.reducer,
		[propertiesApi.reducerPath]: propertiesApi.reducer,
		[contactsApi.reducerPath]: contactsApi.reducer,
		[dealsApi.reducerPath]: dealsApi.reducer,
		[dealMessagesApi.reducerPath]: dealMessagesApi.reducer,
		[dealMeetingsApi.reducerPath]: dealMeetingsApi.reducer,
		[dealNotesApi.reducerPath]: dealNotesApi.reducer,
		[dealTasksApi.reducerPath]: dealTasksApi.reducer,
		[dealHistoryApi.reducerPath]: dealHistoryApi.reducer,
		[rentalsApi.reducerPath]: rentalsApi.reducer,
		[rentalAutomationApi.reducerPath]: rentalAutomationApi.reducer,
		[rentalNotesApi.reducerPath]: rentalNotesApi.reducer,
		[rentalTasksApi.reducerPath]: rentalTasksApi.reducer,
		[rentalMessagesApi.reducerPath]: rentalMessagesApi.reducer,
		[rentalHistoryApi.reducerPath]: rentalHistoryApi.reducer,
		[rentalDocumentsApi.reducerPath]: rentalDocumentsApi.reducer,
		[invoicesApi.reducerPath]: invoicesApi.reducer,
		[financesApi.reducerPath]: financesApi.reducer,
		[documentsApi.reducerPath]: documentsApi.reducer,
		[integrationApi.reducerPath]: integrationApi.reducer,
		[dashboardApi.reducerPath]: dashboardApi.reducer,
		[tasksApi.reducerPath]: tasksApi.reducer,
		[notificationsApi.reducerPath]: notificationsApi.reducer,
		[builderApi.reducerPath]: builderApi.reducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware().concat(
			usersApi.middleware,
			accountApi.middleware,
			propertiesApi.middleware,
			contactsApi.middleware,
			dealsApi.middleware,
			dealMessagesApi.middleware,
			dealMeetingsApi.middleware,
			dealNotesApi.middleware,
			dealTasksApi.middleware,
			dealHistoryApi.middleware,
			rentalsApi.middleware,
			rentalAutomationApi.middleware,
			rentalNotesApi.middleware,
			rentalTasksApi.middleware,
			rentalMessagesApi.middleware,
			rentalHistoryApi.middleware,
			rentalDocumentsApi.middleware,
			invoicesApi.middleware,
			financesApi.middleware,
			documentsApi.middleware,
			integrationApi.middleware,
			dashboardApi.middleware,
			tasksApi.middleware,
			notificationsApi.middleware,
			builderApi.middleware,
		),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
